import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    PrestadorComposicaoAba,
    PrestadorComposicaoEspecialidadesRequest,
    PrestadorComposicaoEspecialidadesResponse,
    PrestadorComposicaoHistoricoRemocaoRequest,
    PrestadorComposicaoItemRequest,
    PrestadorComposicaoRemocaoRequest,
    PrestadorComposicaoResponse,
    PrestadorComposicaoTipoRequest,
    PrestadorComposicaoTipo,
    PrestadorCorpoClinicoMedicoResponse
} from '@/core/api/sicom-api/registro/prestador/prestador-composicao.model';
import { PrestadorComissaoTipo } from '@/core/api/sicom-api/registro/prestador/prestador-comissoes.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PrestadorComposicaoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.composicao;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, composicao: PrestadorComposicaoAba, context?: HttpContext): Observable<PrestadorComposicaoResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('composicao', composicao);
        return this.http.get<PrestadorComposicaoResponse>(this.PATH, { params: httpParams, context });
    }

    incluir(body: PrestadorComposicaoItemRequest, context?: HttpContext): Observable<PrestadorComposicaoResponse> {
        return this.http.post<PrestadorComposicaoResponse>(this.PATH, body, { context });
    }

    atualizar(body: PrestadorComposicaoItemRequest, context?: HttpContext): Observable<PrestadorComposicaoResponse> {
        return this.http.put<PrestadorComposicaoResponse>(this.PATH, body, { context });
    }

    removerHistorico(body: PrestadorComposicaoHistoricoRemocaoRequest, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/historico`, { body, context });
    }

    remover(body: PrestadorComposicaoRemocaoRequest, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(this.PATH, { body, context });
    }

    buscarEspecialidades(params: PrestadorComposicaoEspecialidadesRequest, context?: HttpContext): Observable<PrestadorComposicaoEspecialidadesResponse> {
        const httpParams = new HttpParams().set('id', String(params.id)).set('uf', params.uf).set('idMedico', String(params.idMedico)).set('ufMedico', params.ufMedico).set('dtEntrada', params.dtEntrada);
        return this.http.get<PrestadorComposicaoEspecialidadesResponse>(`${this.PATH}/especialidades`, { params: httpParams, context });
    }

    salvarTipo(body: PrestadorComposicaoTipoRequest, context?: HttpContext): Observable<PrestadorComposicaoResponse> {
        return this.http.put<PrestadorComposicaoResponse>(`${this.PATH}/tipo`, body, { context });
    }

    buscarMedicosDoCorpoClinico(params: { id: number; uf: string; excluirMembrosComissaoAtivos?: PrestadorComissaoTipo | null }, context?: HttpContext): Observable<PrestadorCorpoClinicoMedicoResponse[]> {
        let httpParams = new HttpParams().set('id', String(params.id)).set('uf', params.uf);
        if (params.excluirMembrosComissaoAtivos) {
            httpParams = httpParams.set('excluirMembrosComissaoAtivos', params.excluirMembrosComissaoAtivos);
        }
        return this.http.get<PrestadorCorpoClinicoMedicoResponse[]>(`${this.PATH}/medicos`, { params: httpParams, context });
    }
}
